<div class="modal-header">{{ title }}</div>
<div class="modal-body">
    <p *ngIf="isTestRegistrationTemplate">{{ body }} <a class="cm-link" [href]="link" target="_blank">link</a>.</p>
    <p class="title">Credential name:</p>
    <p class="name">{{ certificateName }}</p>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="back()">BACK</button>
    <button class="btn btn-primary" type="button" (click)="confirm()">Confirm</button>
</div>
